import { makeObservable, observable, computed, action } from 'mobx'
import dayjs from 'dayjs'
/**
 * Class representing a Notification item.
 * Contains additional properties and methods specific to Notification items.
 *
 * @class Notification
 */
export class Notification {
	_class = 'Notification'
	notification_id = ''
	for_user_id = ''
	entity_table = ''
	entity_uid = ''
	kind = ''
	progress = ''
	created_at = ''
	to_delete = false

	/**
	 * Creates an instance of Notification.
	 * @param {string} id - The unique identifier for the Notification item.
	 */
	constructor(id) {
		this.notification_id = id

		makeObservable(this, {
			notification_id: observable,

			for_user_id: observable,
			setForUserId: action.bound,

			entity_table: observable,
			setEntityTable: action.bound,

			entity_uid: observable,
			setEntityId: action.bound,

			kind: observable,
			setKind: action.bound,

			progress: observable,
			setProgress: action.bound,

			created_at: observable,
			createdTs: computed,

			to_delete: observable,
			setToDelete: action.bound,

			updateFromServer: action
		})
	}

	/**
	 * Sets the ID of the user for whom the notification is intended.
	 *
	 * @param {string} value - The ID of the user to set.
	 */
	setForUserId(value) {
		this.for_user_id = value
	}

	/**
	 * Sets the table associated with the notification.
	 *
	 * @param {string} value - The name of the table to set.
	 */
	setEntityTable(value) {
		this.entity_table = value
	}

	/**
	 * Sets the type of the notification.
	 *
	 * @param {string} value - The type of the notification to set.
	 */
	setKind(value) {
		this.kind = value
	}

	/**
	 * Sets the entity ID associated with the notification.
	 *
	 * @param {string} value - The entity ID to set.
	 */
	setEntityId(value) {
		this.entity_uid = value
	}

	/**
	 * Sets the progress associated with the notification.
	 *
	 * @param {string} value - The progress to set.
	 */
	setProgress(value) {
		this.progress = value
	}

	/**
	 * Sets the to_delete associated with the notification.
	 *
	 * @param {string} value - The to_delete - true or false.
	 */
	setToDelete(value) {
		this.to_delete = value
	}

	get createdTs() {
		return dayjs(this.created_at).unix()
	}

	/**
	 * Updates the item with the data from the server.
	 * @param {object} srvJson - The server data.
	 */
	updateFromServer(srvJson) {
		this.notification_id = srvJson.notification_id
		this.for_user_id = srvJson.for_user_id
		this.entity_table = srvJson.entity_table
		this.entity_uid = srvJson.entity_uid
		this.kind = srvJson.kind
		this.progress = srvJson.progress
		this.created_at = srvJson.created_at
		// Due to special nature of deletion based on progress, we will convert the date to unix here
		this.to_delete = srvJson.to_delete
			? dayjs(srvJson.to_delete).unix()
			: false
	}
}
